/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tournament_Registered_PlayersInputs */



/**
* | output |
* | --- |
* | "Registered players ({count})" |
*
* @param {Tournament_Registered_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_registered_players = /** @type {((inputs: Tournament_Registered_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Registered_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Joueurs inscrits (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Jugadores inscritos (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Jogadores inscritos (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Giocatori iscritti (${i?.count})`)
	return /** @type {LocalizedString} */ (`Registered players (${i?.count})`)
});